const containerRadius = (isCompact: boolean, isBranded: boolean) => {
  if (isBranded)
    return isCompact
      ? "rounded-[var(--button-brand-radius,0.8rem)]"
      : "rounded-[var(--button-brand-radius,1.2rem)]";

  return isCompact ? "rounded" : "rounded-[1.2rem]";
};
const itemRadius = (isCompact: boolean, isBranded: boolean) => {
  if (isBranded)
    return isCompact
      ? "rounded-[var(--button-brand-radius,0.4rem)]"
      : "rounded-[var(--button-brand-radius,0.8rem)]";

  return isCompact ? "rounded-[0.4rem]" : "rounded";
};

export const containerBase = (isCompact: boolean, isBranded: boolean) =>
  `flex text-ui bg-black/5 ${containerRadius(isCompact, isBranded)} p-[0.4rem] gap-small`;
export const labelBase = (isCompact: boolean, isBranded: boolean) =>
  `flex items-center gap-xSmall px-[1.2rem] ${isCompact ? "py-[0.2rem]" : "py-[0.5rem]"} ${itemRadius(isCompact, isBranded)} font-semibold text-neutral-600 outline-none border-[0.1rem] border-black/0`;
export const iconBase = (isCompact: boolean, isBranded: boolean) =>
  `flex items-center justify-center ${isCompact ? "h-[2.4rem] w-[2.4rem]" : "h-[3.2rem] w-[3.2rem]"} ${itemRadius(isCompact, isBranded)} font-semibold text-neutral-600 outline-none border-[0.1rem] border-black/0`;
export const hover = "hover:bg-black/5";
export const disabled = "disabled:text-neutral-400 disabled:cursor-not-allowed";
export const border =
  "focus:outline-blue-560 focus:outline-[0.1rem] focus:border-[0.1rem] focus:border-white focus:bg-black/5";
export const active =
  "aria-checked:bg-white aria-checked:text-black aria-checked:border-[0.1rem] aria-checked:border-black/15 aria-checked:outline-black/5 aria-checked:outline-1 outline-offset-0";
